import { isArray, formatUrl, resolvePath, removePath, isNullOrUndefined } from '@config/utils';
import BasePermissionsMixin from './BasePermissionsMixin';
import BaseGenericApplicationMixin from './BaseGenericApplicationMixin';

export default {
    mixins: [BasePermissionsMixin, BaseGenericApplicationMixin],
    components: {
        HeaderList: () => import(/* webpackChunkName: "header-list" */ '@/app/shared/components/manage/ManageHeaderList'),
        ColumnActions: () => import(/* webpackChunkName: "column-actions" */ '@/app/shared/components/tables/ColumnActions'),
        ButtonsFooter: () => import(/* webpackChunkName: "buttons-footer" */ '@/app/shared/components/manage/ManageButtonsFooter'),
        TableData: () => import(/* webpackChunkName: "table-data" */ '@/app/shared/components/tables/DataTable'),
        ModalConfirmation: () => import(/* webpackChunkName: "modal-confirmation" */ '@/app/shared/components/modals/ModalConfirmation')
    },
    data() {
        return {
            pageID: null,
            pageTitle: '',
            autoloadItem: true,
            timerSearch: null,
            list: [],
            lists: {
                loaded: false,
                onoff: [
                    { id: 1, name: this.$t ? this.$t('global.true') : 'True', code: 1, bool: true },
                    { id: 2, name: this.$t ? this.$t('global.false') : 'False', code: 0, bool: false }
                ]
            },
            errorLoadData: null,
            table: {
                addParamsToUrl: true,
                loadingMsg: 'global.table.loading',
                notFoundMsg: 'global.table.no-data',
                orderByTemplate: 'global.table.order-by-template',
                autoUpdateFilter: true,
                autoUpdateExternalFilter: false,
                settings: {},
                columns: [],
                filters: {
                    q: ''
                }
            },
            query: '',
            queryParams: {
                filters: 'filter'
            },
            form: {
                id: null
            },
            help: {
                status: 'Permite ativar/desativar'
            },
            excludeFromSave: [],
            loading: false
        };
    },
    mounted() {
        if (this.$route.meta.title) {
            let title = this.$route.meta.title;
            let i8nTitle = this.$t(title);
            this.pageTitle = i8nTitle == title ? title : i8nTitle;
        }

        if (!isNullOrUndefined(this.$route.params.id)) {
            this.initializeItem(this.$route.params.id);
        } else if (this.$route.name.endsWith('.create')) {
            this.loadDefaultValues();
        }
        this.activeTooltip();
    },
    computed: {
        excludeFromSaveComputed() {
            return [];
        },
        isLoading() {
            return this.$store.getters.loading;
        },
        titleItem() {
            let prefix = this.hasId ? this.updateTitle : this.addTitle;
            return (prefix ? `${prefix} - ` : '') + this.pageTitle;
        },
        titleConfigItem() {
            let prefix = this.configTitle;
            return (prefix ? `${prefix} - ` : '') + this.pageTitle;
        },
        hasData() {
            return this.list && this.list.length > 0;
        },
        errorOccurred: function () {
            return this.errorLoadData != null;
        },
        hasId: function () {
            return !isNullOrUndefined(this.form.id);
        }
    },
    methods: {
        setLoading(flag) {
            this.$store.dispatch('setLoading', flag);
        },
        initializeItem(id) {
            this.form.id = id;
            if (this.autoloadItem) {
                this.loadItem().then(res => {
                    if (res) {
                        this.callbackLoadItem();
                    }
                });
            }
        },
        resolvePath(obj, path) {
            return resolvePath(obj, path);
        },
        normalizeSortOrder() {
            this.sortOrder.forEach(function (item) {
                item.sortField = item.sortField || item.field;
            });
        },
        urlLists: function (id = this.form.id, url = this.url?.getLists) {
            return url ? formatUrl(url, { applicationCode: this.applicationCode, id }) : null;
        },
        async loadLists(url = this.urlLists(), params = {}) {
            if (!this.lists.loaded && url) {
                return await this.$http
                    .get(url, { params })
                    .then(res => {
                        let data = res.data ? res.data : res;
                        Object.keys(data).forEach(key => {
                            if (key in this.lists) {
                                this.lists[key] = data[key];
                            }
                        });
                        this.lists.loaded = true;
                        return data;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                        return false;
                    });
            }
            return Promise.resolve(false);
        },
        async loadData(queryParams) {
            if (this.canView) {
                let url = this.url?.getList;
                if (url) {
                    if (!!queryParams && !('params' in queryParams)) {
                        queryParams = { params: queryParams };
                    }
                    let httpOptions = queryParams
                        ? queryParams
                        : {
                              params: this.getQueryParams()
                          };
                    this.loading = true;
                    return await this.$http
                        .get(formatUrl(url, { applicationCode: this.applicationCode }), httpOptions)
                        .then(res => {
                            let data = res.data ? res.data : res;
                            data = data.data ? data.data : data;
                            this.$set(this, 'list', data);
                            this.errorLoadData = null;
                            return true;
                        })
                        .catch(error => {
                            this.errorLoadData = error;
                            this.showHttpError(error);
                            return false;
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                }
            }
            return Promise.resolve(false);
        },
        async loadItem(url = this.url.getShow, forceId = true) {
            if (this.canDetail && url && ((forceId && !isNullOrUndefined(this.form.id)) || !forceId)) {
                let httpOptions = {
                    params: this.getRouteQueryParams()
                };
                return await this.$http
                    .get(formatUrl(url, { applicationCode: this.applicationCode, id: this.form.id }), httpOptions)
                    .then(res => {
                        this.form = Object.assign(this.form, this.getLoadedItemData(res));
                        this.resetValidator();
                        this.activeTooltip();
                        return true;
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 403) {
                            this.handleBack();
                        }
                        this.showHttpError(error);
                        return false;
                    });
            }
            return Promise.resolve(false);
        },
        callbackLoadItem() {},
        async loadConfig(url = this.url.getConfig) {
            if (url) {
                return await this.loadItem(url, false);
            } else {
                return Promise.resolve(false);
            }
        },
        async loadDefaultValues(url = this.url.getDefaultValues) {
            if (url) {
                return await this.loadItem(url, false).then(res => {
                    if (res) {
                        this.callbackLoadDefaultValues();
                    }
                    return res;
                });
            } else {
                return Promise.resolve(false);
            }
        },
        callbackLoadDefaultValues() {},
        async deleteItem(id, data, callback) {
            if (this.canDelete) {
                let url = this.url?.getDelete;
                if (url) {
                    return await this.$http
                        .delete(formatUrl(url, { applicationCode: this.applicationCode, id }))
                        .then(res => {
                            this.showMessage(res.data.data);
                            if (callback && typeof callback === 'function') {
                                callback(id, data);
                            }
                            return true;
                        })
                        .catch(error => {
                            this.showHttpError(error);
                            return false;
                        });
                }
            }
            return Promise.resolve(false);
        },
        // [TODO] apagar quando todo o codigo que usa esta função for atualizado
        async saveItemOldWay(fallback=false, excludeBuildFormData=['legends'], data={}, isConfig=false, suffixFiles='_files') {
            let resultData = {...(data||{})};
            if((isConfig && this.canConfigEdit) || (!isConfig && (this.hasId && this.canEdit || !this.hasId && this.canAdd))) {
                this.clearMessages();

                const makeRequest = async () => {
                    let config = {params: {}};
                    if(this.hasId || isConfig) {
                        // POR VEZES A API DEVOLVE "The POST method is not supported for this route. Supported methods: GET, HEAD, PUT, PATCH, DELETE."
                        // ATÉ AO MOMENTO VERIFIQUEI QUE ISTO ACONTECE QUANDO É content-type: multipart/form-data
                        config.params['_method'] = 'PUT';
                        this.form["_method"] = this.hasId || isConfig ? "PUT" : "POST";
                    }

                    function buildFormData(formData, data, parentKey, exclude=[]) {
                        if (data
                                && typeof data === 'object'
                                && !(data instanceof Array && data.length==0)
                                && !(data instanceof Date)
                                && !(data instanceof File)) {
                            Object.keys(data).forEach(key => {
                                if(exclude && !exclude.includes(key)){
                                    buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key, exclude);
                                }
                            });
                        } else {
                            const value = data == null ? '' : data;
                            formData.append(parentKey, value);
                        }
                    }

                    let formData = new FormData();
                    buildFormData(formData, this.form, null, excludeBuildFormData || []);

                    if(excludeBuildFormData){
                        excludeBuildFormData.forEach(item => {
                            let values = this[item] || this.form[item];
                            if(values){
                                if(isArray(values)){
                                    let originalFiles = [];
                                    for (let x = 0; x < values.length; x++) {
                                        let val = values[x];
                                        if(val.file){
                                            formData.append(`${item}${suffixFiles}[]`, val.file);
                                        }else if(val.path){
                                            originalFiles.push(val);
                                        }
                                    }

                                    if(originalFiles.length>0){
                                        buildFormData(formData, originalFiles, item);
                                    }
                                }
                            }
                        });
                    }

                    let url = isConfig ? this.url.getConfig : (this.hasId ? this.url.getUpdate : this.url.getCreate);
                    return await this.$http.post(formatUrl(url, {applicationCode: this.applicationCode, id: this.form.id}), formData, config)
                    .then( res => {
                        res = res.data || res;
                        resultData = {...resultData, ...res};
                        this.showMessage(res.data);

                        if(fallback && typeof fallback === "function"){
                            fallback(resultData);
                        }else{
                            this.handleBack(fallback, fallback instanceof Event ? false : !!fallback);
                        }

                        return true;
                    })
                    .catch( error => {
                        this.showHttpError(error);
                        return false;
                    })
                }

                const result = await this.$validator.validateAll('form').then(result => {
                    if(!result){
                        this.showError(this.$t(`global.msg.error.form`));
                        return false;
                    }
                    return true;
                }).then(async (res) => {
                    if(!res) {
                        return false;
                    }

                    return await makeRequest();
                })
                .catch(error => {
                    return false;
                });
                return result ? {...resultData, ...{status: resultData.status_code}} : false;
            }
        },
        async saveItem(fallback = false, excludeFromSave = [], data = {}, isConfig = false, suffixFiles = '_files') {
            excludeFromSave = [...excludeFromSave, ...this.excludeFromSaveComputed, ...this.excludeFromSave];
            let resultData = { ...(data || {}) };
            if ((isConfig && this.canConfigEdit) || (!isConfig && ((this.hasId && this.canEdit) || (!this.hasId && this.canAdd)))) {
                this.clearMessages();

                let _data = JSON.parse(JSON.stringify(this.form));
                if (excludeFromSave) {
                    excludeFromSave.forEach(path => {
                        _data = removePath(_data, path);
                    });
                }

                const makeRequest = async () => {
                    let config = { params: {} };
                    let formData = new FormData();
                    if (this.hasId || isConfig) {
                        // POR VEZES A API DEVOLVE "The POST method is not supported for this route. Supported methods: GET, HEAD, PUT, PATCH, DELETE."
                        // ATÉ AO MOMENTO VERIFIQUEI QUE ISTO ACONTECE QUANDO É content-type: multipart/form-data
                        config.params['_method'] = 'PUT';
                        formData.append('_method', this.hasId || isConfig ? 'PUT' : 'POST');
                    }

                    function buildFormData(formData, data, filteredData, parentKey, exclude = []) {
                        let __data = parentKey == null ? filteredData : data;
                        if (__data && typeof __data === 'object' && !(__data instanceof Array && __data.length == 0) && !(__data instanceof Date) && !(__data instanceof File)) {
                            let keys = Object.keys(filteredData);
                            let fileExists = keys.find(key => data[key] instanceof File);
                            if (fileExists) {
                                keys = keys.filter(k => k != 'path');
                            }
                            keys.forEach(key => {
                                if (exclude && !exclude.includes(key)) {
                                    buildFormData(formData, data[key], filteredData[key], parentKey ? `${parentKey}[${key}]` : key, exclude);
                                }
                            });
                        } else {
                            const value = __data == null ? '' : __data;
                            formData.append(parentKey, value);
                        }
                    }
                    buildFormData(formData, this.form, _data, null, excludeFromSave || []);

                    // FILES
                    if (excludeFromSave) {
                        excludeFromSave.forEach(path => {
                            let values = this[path] || this.form[path];
                            if (values) {
                                if (isArray(values)) {
                                    let originalFiles = [];
                                    for (let x = 0; x < values.length; x++) {
                                        let val = values[x];
                                        if (val.file) {
                                            formData.append(`${path}${suffixFiles}[]`, val.file);
                                        } else if (val.path) {
                                            originalFiles.push(val);
                                        }
                                    }

                                    if (originalFiles.length > 0) {
                                        buildFormData(formData, originalFiles, path);
                                    }
                                }
                            }
                        });
                    }

                    let url = isConfig ? this.url.getConfig : this.hasId ? this.url.getUpdate : this.url.getCreate;
                    return await this.$http
                        .post(formatUrl(url, { applicationCode: this.applicationCode, id: _data.id }), formData, config)
                        .then(res => {
                            res = res.data || res;
                            resultData = { ...resultData, ...res };
                            this.showMessage(res.data);

                            if (fallback && typeof fallback === 'function') {
                                fallback(resultData);
                            } else {
                                this.handleBack(fallback, fallback instanceof Event ? false : !!fallback);
                            }

                            return true;
                        })
                        .catch(error => {
                            this.showHttpError(error);
                            return false;
                        });
                };

                const result = await this.$validator
                    .validateAll('form')
                    .then(result => {
                        if (!result) {
                            this.showError(this.$t(`global.msg.error.form`));
                            return false;
                        }
                        return true;
                    })
                    .then(async res => {
                        if (!res) {
                            return false;
                        }

                        return await makeRequest();
                    })
                    .catch(error => {
                        return false;
                    });
                return result ? { ...resultData, ...{ status: resultData.status_code } } : false;
            }
        },
        async onSaveItem(route) {
            return await this.saveItem(route);
            // return await (route ? this.saveItem() : this.saveItem(route === true ? `${moduleCode}.${pageID}` : route));
        },
        getLoadedItemData(res) {
            let data = res.data ? res.data : res;
            return data.data ? data.data : data;
        },
        getAllQueryParams() {
            let params = {};
            this.table.filters.q = this.query;
            // params[this.queryParams.filters] = Object.assign({}, this.$route.query, this.table.filters);
            params[this.queryParams.filters] = JSON.stringify(Object.assign({}, this.$route.query[this.queryParams.filters] || {}, this.table.filters));
            return params;
        },
        getQueryParams() {
            return Object.assign({}, this.getRouteQueryParams(), this.getAllQueryParams());
            // return Object.assign({}, this.getAllQueryParams());
        },
        getRouteQueryParams() {
            return Object.assign({}, this.$route.query);
        },
        async onSearch() {
            if (this.timerSearch) {
                clearTimeout(this.timerSearch);
                this.timerSearch = null;
            }
            this.timerSearch = setTimeout(() => {
                this.loadData();
            }, 2000); // delay
        },

    }
};
